"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DownloadStepContracts_1 = require("./DownloadStepContracts");
var DropdownStep_1 = __importDefault(require("./DropdownStep"));
var GlobalStateContext_1 = require("../../utils/GlobalStateContext");
var ProductCategoryDropdownStep = function () {
    // global state context things
    var context = (0, react_1.useContext)(GlobalStateContext_1.GlobalStateContext);
    var state = context.state, setState = context.setState;
    var setProdCatNodeId = function (newProdCatNodeId) { return setState(function (prevState) { return (__assign(__assign({}, prevState), { productCategoryNodeId: newProdCatNodeId, 
        // reset product group states
        productGroupNodeId: "", productGroupOptions: [], 
        // reset product states
        productDetailNodeId: "", productDetailOptions: [state.pleaseSelectOption], 
        // reset article states
        articleId: "", articleOptions: [state.pleaseSelectOption] })); }); };
    // label text
    var _a = (0, react_1.useState)(''), labelText = _a[0], setLabelText = _a[1];
    (0, react_1.useEffect)(function () {
        setLabelText(window.bes.spareparts.dropdown1text);
    }, []);
    // handler ------------------------------------------------------------------------------------
    var handleDropdownChange = function (event) {
        event.preventDefault();
        setProdCatNodeId(event.target.value);
    };
    // rendering ----------------------------------------------------------------------------------
    return (react_1.default.createElement(DropdownStep_1.default, { id: "dropdownProductCategory", label: labelText, stepNumber: "1", isEnabled: true, options: state.productCategoryOptions, selectedValue: state.productCategoryNodeId, prevStatus: DownloadStepContracts_1.DropdownStepProcessStatus.hidden, nextStatus: DownloadStepContracts_1.DropdownStepProcessStatus.enabled, handleChange: handleDropdownChange }));
};
ProductCategoryDropdownStep.displayName = "Product Category Dropdown Step";
exports.default = ProductCategoryDropdownStep;
